export default {
  routeImporter: {
    loadRouteFile: 'Import souboru',
    failedToLoadFile: 'Nepodařilo se načíst vybraný soubor. Ujistěte se, že soubor není poškozený a je v jednom z přijatelných formátů.',
    acceptedImportTypes: 'Přijatelné typy importu',
    dictDefaultMessage: 'Vložte soubor s trasou, který chcete importovat, nebo klikněte sem',
    dictFallbackMessage: 'Prohlížeč není podporovaný',
    dictFileTooBig: 'Soubor je příliš velký',
    dictInvalidFileType: 'Nesprávný typ souboru',
    dictCancelUpload: 'Zrušit nahrávání',
    dictUploadCanceled: 'Nahrávání zrušeno',
    dictRemoveFile: 'Odebrat soubor'
  }
}
